import React, { useState, useEffect } from 'react';
import styles from './RawHtmlEditor.module.css';

interface RawHtmlEditorProps {
  initialHtml?: string;
  onChange?: (html: string) => void;
}

const RawHtmlEditor: React.FC<RawHtmlEditorProps> = ({
  initialHtml = '',
  onChange,
}) => {
  const [html, setHtml] = useState(initialHtml);

  useEffect(() => {
    setHtml(initialHtml);
  }, [initialHtml]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setHtml(newValue);
    // Pass raw value up:
    if (onChange) onChange(newValue);
  };

  return (
    <div className={styles.editor}>
      <textarea
        className={styles.htmlInput}
        value={html}
        onChange={handleChange}
        placeholder="Enter your HTML here..."
      />
    </div>
  );
};

export default RawHtmlEditor;